<template>
  <card style="width: 80%; margin: auto; margin-top: 3em;" v-if="loadPage == 2">
    <template #content>
      <div>

        <!-- Choix boîte (secrétaire uniquement) -->
        <div class="boite" v-if="this.$store.state.user.role.label == 'secretaire'">
          <h4 class="titleMoniteurs">1/ Choisissez le type de véhicule</h4>
          <div class="choice">
            <label class="container">Boîte Manuelle (20h minimum - {{ prixBm }}€ /h)
              <input type="radio" checked="checked" name="radio" value="BM" v-model="boite" @change="displayMono">
              <span class="checkmark"></span>
            </label>
            <label class="container">Boîte Automatique (13h minimum - {{ prixBa }}€ /h)
              <input type="radio" name="radio" value="BA" v-model="boite" @change="displayMono">
              <span class="checkmark"></span>
            </label>
          </div>
        </div>

        <!-- Choix moniteurs -->
        <div class="moniteur">
          <div class="moniteur-header">
            <h4 class="titleMoniteurs" v-if="this.$store.state.user.role.label == 'secretaire'">
              2/ Choisissez vos moniteurs et vos lieux de RDV
            </h4>
            <h4 class="titleMoniteurs" v-else>
              Choisissez vos moniteurs et vos lieux de RDV
            </h4>
            <!-- Compteur 0/3 -->
            <div class="counter-pill">
              <span class="dot" :class="{ 'dot-active': choixMono.length >= 1 }"></span>
              <span class="dot" :class="{ 'dot-active': choixMono.length >= 2 }"></span>
              <span class="dot" :class="{ 'dot-active': choixMono.length >= 3 }"></span>
              <span class="counter-text">{{ choixMono.length }} / 3 moniteurs</span>
            </div>
          </div>
          <p v-if="this.$store.state.user.role.label !== 'secretaire'">* Seule l'agence pourra réserver des cours sur les lieux de rendez-vous autres que celui de l'agence. Le choix de ces lieux vous permettra de notifier à l'agence les lieux qui vous intéressent et de poser des disponibilités sur ces lieux choisis.</p>
          <div class="choice">

            <!-- Colonne gauche : liste des moniteurs -->
            <div class="moniteurList">
              <h4 class="sstitre">Choix des moniteurs</h4>

              <div
                v-for="m in moniteurs"
                :key="m.id"
                class="mono-row"
                :class="{ 'mono-selected': m.choixEleve, 'mono-viewing': monoSelect && monoSelect.idMono === m.idMono }"
              >
                <!-- Dot indicateur lieux choisis -->
                <span
                  class="status-dot"
                  :class="{ 'dot-on': m.choixEleve && getLieuCount(m) > 0 }"
                ></span>

                <!-- Nom cliquable → affiche les lieux à droite -->
                <span
                  class="mono-name"
                  :class="{ 'mono-name-viewing': monoSelect && monoSelect.idMono === m.idMono }"
                  @click="showLieuxMono(m)"
                >
                  {{ m.fullname }}
                  <span v-if="m.choixEleve && getLieuCount(m) > 0" class="lieux-count-badge">
                    {{ getLieuCount(m) }}
                  </span>
                </span>

                <!-- Checkbox sélection moniteur -->
                <div
                  class="mono-check"
                  :class="{ 'checked': m.choixEleve, 'disabled': !m.choixEleve && choixMono.length >= 3 }"
                  :title="m.choixEleve ? 'Désélectionner' : (choixMono.length >= 3 ? '3 moniteurs maximum' : 'Sélectionner')"
                  @click="toggleMono(m)"
                >
                  <svg v-if="m.choixEleve" width="11" height="11" viewBox="0 0 12 12" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="1.5,6 4.5,9.5 10.5,2.5"/>
                  </svg>
                </div>
              </div>
            </div>

            <!-- Colonne droite : lieux du moniteur sélectionné -->
            <div class="lieuList">
              <h4 class="sstitre" v-if="monoSelect">
                Choix des lieux : {{ monoSelect.fullname }}
              </h4>
              <h4 class="sstitre" v-else>Choix des lieux</h4>

              <!-- État vide -->
              <div v-if="!monoSelect" class="lieux-empty">
                <div class="lieux-empty-icon">📍</div>
                Cliquez sur le <strong>nom d'un moniteur</strong><br>pour voir ses lieux de RDV
              </div>

              <!-- Liste des lieux -->
              <template v-if="monoSelect && lieuMoniteur.length > 0">
                <template v-for="l in lieuMoniteur" :key="l.id">
                <div
                  v-if="l.get == true"
                  class="lieu-row"
                  :class="{
                    'lieu-selected': l.choixEleve,
                    'lieu-disabled': !monoSelect.choixEleve && choixMono.length >= 3
                  }"
                  @click="setLieu(l)"
                >
                  <div class="lieu-check" :class="{ 'on': l.choixEleve }">
                    <svg v-if="l.choixEleve" width="9" height="9" viewBox="0 0 12 12" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="1.5,6 4.5,9.5 10.5,2.5"/>
                    </svg>
                  </div>
                  <span class="lieu-name">{{ l.nom }}</span>
                  <span v-if="l.groupe === 2 || l.groupe === 3" class="lieu-agence-msg">
                    Les cours vous seront proposés par l'agence =&gt; posez vos dispos pour ce lieu sur le planning
                  </span>
                  <span v-if="!monoSelect.choixEleve && choixMono.length >= 3" class="lieu-locked">max atteint</span>
                </div>
                </template>
              </template>
            </div>

          </div>
        </div>

        <!-- Footer sélection + valider -->
        <div class="selection-footer">
          <span class="footer-label">Sélection</span>
          <div class="footer-chips">
            <span v-if="choixMono.length === 0" class="footer-empty">Aucun moniteur sélectionné</span>
            <span
              v-for="c in choixMono"
              :key="c.id"
              class="selection-chip"
            >
              {{ getMonoName(c.id) }}
              <span v-if="c.lieux && c.lieux.length > 0" class="chip-lieu-count">
                · {{ c.lieux.length }} lieu{{ c.lieux.length > 1 ? 'x' : '' }}
              </span>
              <button class="chip-remove" @click="removeMonoChip(c.id)">×</button>
            </span>
          </div>
          <button v-if="!loadBtn" class="btn-valider" @click="setChoixEleve">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            Valider
          </button>
          <button v-else class="btn-valider btn-valider-loading" disabled>
            <i class="fa fa-spinner fa-spin"></i> Valider
          </button>
        </div>

      </div>
    </template>
  </card>

  <template v-else>
    <div><Loader /></div>
  </template>
</template>

<script>
import Loader from "@/components/Loader.vue";

export default {

  props: [
    "eleve",
    "choixDispo",
    "getEleveInfo",
    "closeModalChoixEleve",
    "setNewChoixDispo",
    "modalChoixEleve"
  ],

  components: { Loader },

  data() {
    return {
      moniteurs: [],
      allMoniteurs: [],
      unMoniteurs: [],
      choixMono: [],
      lieuMoniteur: [],
      monoSelect: null,
      loadMono: 0,
      boite: "BM",
      prixBm: 0,
      prixBa: 0,
      loadPage: 0,
      loadBtn: false,
    };
  },

  mounted() {
    if (this.choixDispo != "n" && this.choixDispo != null && this.choixDispo != []) {
      this.choixMono = this.choixDispo.choix;
    }
    this.getFonctionnalite();
    this.getMoniteurs();
    this.boite = this.eleve.boite == 1 ? "BA" : "BM";
    console.log("this.eleve :! ", this.eleve)
  },

  methods: {

    // Retire les moniteurs simulateur si l'élève n'a pas d'heures simu à faire
    applySimuFilter(monitors) {
      if (this.eleve.nbHeureSimu !== 'not' && this.eleve.nbHeureSimu !== 0) return monitors;
      const simuIds = this.allMoniteurs
        .filter(m => m.surnom === 'Simu')
        .map(m => m.idMono);
      if (simuIds.length === 0) return monitors;
      this.choixMono = this.choixMono.filter(c => !simuIds.includes(c.id));
      this.moniteurs.forEach(m => {
        if (simuIds.includes(m.idMono)) m.choixEleve = false;
      });
      if (this.monoSelect && simuIds.includes(this.monoSelect.idMono)) {
        this.monoSelect = null;
        this.lieuMoniteur = [];
      }
      return monitors.filter(m => !simuIds.includes(m.idMono));
    },

    // Retourne le nom d'un moniteur depuis son id
    getMonoName(id) {
      const mono = this.moniteurs.find(m => m.idMono == id);
      return mono ? mono.fullname : id;
    },

    // Supprime un moniteur via le chip du footer
    removeMonoChip(id) {
      const mono = this.moniteurs.find(m => m.idMono == id);
      if (mono) mono.choixEleve = false;
      this.choixMono = this.choixMono.filter(c => c.id != id);
      if (this.monoSelect && this.monoSelect.idMono == id) {
        this.monoSelect = null;
        this.lieuMoniteur = [];
      }
    },

    // Retourne le nombre de lieux choisis pour un moniteur
    getLieuCount(mono) {
      const found = this.choixMono.find(c => c.id == mono.idMono);
      return (found && found.lieux) ? found.lieux.length : 0;
    },

    // Clic sur le nom du moniteur → affiche ses lieux à droite (sans toucher à la sélection)
    showLieuxMono(mono) {
      // Toggle : si c'est déjà celui affiché, on ferme
      if (this.monoSelect && this.monoSelect.idMono === mono.idMono) {
        this.monoSelect = null;
        this.lieuMoniteur = [];
        return;
      }

      this.monoSelect = mono;
      this.lieuMoniteur = mono.lieux;

      // Réinitialise choixEleve des lieux puis recharge depuis choixMono
      this.lieuMoniteur.forEach(l => { l.choixEleve = false; });

      if (this.choixMono && this.choixMono.length > 0) {
        this.lieuMoniteur.forEach(l => {
          this.choixMono.forEach(c => {
            if (c.id == mono.idMono && c.lieux) {
              c.lieux.forEach(li => {
                if (l.id == li) l.choixEleve = true;
              });
            }
          });
        });
      }
    },

    // Checkbox : sélectionne ou désélectionne un moniteur (indépendant de l'affichage des lieux)
    toggleMono(mono) {
      if (mono.choixEleve) {
        // Désélectionner
        mono.choixEleve = false;
        this.choixMono = this.choixMono.filter(c => c.id != mono.idMono);

        // Réinitialiser les lieux affichés si c'est ce mono
        if (this.monoSelect && this.monoSelect.idMono === mono.idMono) {
          this.lieuMoniteur.forEach(l => { l.choixEleve = false; });
        }
      } else {
        // Vérifier la limite (en ignorant les moniteurs non disponibles)
        const activeChoix = this.choixMono.filter(c => {
          return !this.unMoniteurs.find(u => u.idMono == c.id);
        });

        if (activeChoix.length >= 3) {
          alert("Vous êtes limité à 3 moniteurs maximum, si vous voulez vraiment choisir ce moniteur veuillez sélectionner un autre moniteur");
          return;
        }

        // Sélectionner
        mono.choixEleve = true;

        // Si le moniteur n'a qu'un seul lieu visible (get == true), le pré-sélectionner
        // avant showLieuxMono pour que sa synchro interne coche automatiquement le lieu
        const lieuxVisibles = mono.lieux ? mono.lieux.filter(l => l.get == true) : [];
        if (lieuxVisibles.length === 1) {
          this.choixMono.push({ id: mono.idMono, lieux: [lieuxVisibles[0].id] });
        } else {
          this.choixMono.push({ id: mono.idMono });
        }

        // Ouvrir automatiquement ses lieux à droite (la synchro lira choixMono)
        this.showLieuxMono(mono);
      }
    },

    // Clic sur un lieu → le coche, et si le moniteur n'est pas sélectionné il le sélectionne aussi
    setLieu(lieu) {
      if (!this.monoSelect) return;

      const atMax = !this.monoSelect.choixEleve && this.choixMono.length >= 3;
      if (atMax) {
        alert("Vous êtes limité à 3 moniteurs maximum, si vous voulez vraiment choisir ce moniteur veuillez sélectionner un autre moniteur");
        return;
      }

      // Si le moniteur n'est pas encore coché → on le coche automatiquement
      if (!this.monoSelect.choixEleve) {
        this.monoSelect.choixEleve = true;
        this.choixMono.push({ id: this.monoSelect.idMono });
      }

      // Toggle le lieu
      if (lieu.choixEleve) {
        // Décocher le lieu
        lieu.choixEleve = false;
        this.choixMono = this.choixMono.map(c => {
          if (c.id == this.monoSelect.idMono) {
            const lieux = (c.lieux || []).filter(l => l != lieu.id);
            // Si plus aucun lieu, on garde quand même le moniteur dans choixMono
            return { ...c, lieux };
          }
          return c;
        });
      } else {
        // Cocher le lieu
        lieu.choixEleve = true;
        let monoFound = false;
        this.choixMono = this.choixMono.map(c => {
          if (c.id == this.monoSelect.idMono) {
            monoFound = true;
            const lieux = c.lieux ? [...c.lieux, lieu.id] : [lieu.id];
            return { ...c, lieux };
          }
          return c;
        });

        if (!monoFound) {
          this.choixMono.push({ id: this.monoSelect.idMono, lieux: [lieu.id] });
        }
      }
    },

    displayMono(e) {
      if (e.target.value === "BM") {
        this.moniteurs = this.applySimuFilter(this.allMoniteurs.filter(r => r.boite != "BA"));
      } else {
        this.moniteurs = this.applySimuFilter(this.allMoniteurs.filter(r => r.boite != "BM"));
      }
      // La sélection de moniteurs n'est valable que pour l'ancienne boîte : on repart de zéro
      this.moniteurs.forEach(m => { m.choixEleve = false; });
      this.choixMono = [];
      // Fermer le panneau lieux si on change de boîte
      this.monoSelect = null;
      this.lieuMoniteur = [];
    },

    getMoniteurs() {
      window.api
        .get("/moniteurs/agence/planning/" + this.$store.state.user.agence.id + "/null", {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then((response) => {
          this.loadPage++;
          this.allMoniteurs = response.data.moniteurs;
          const baseMoniteurs = this.eleve.boite == 1
            ? response.data.moniteurs.filter(e => e.boite != "BM")
            : response.data.moniteurs.filter(e => e.boite != "BA");
          this.moniteurs = this.applySimuFilter(baseMoniteurs);
          this.unMoniteurs = response.data.unMoniteurs;
          this.loadMono++;

          this.moniteurs.forEach(m => { m.choixEleve = false; });

          if (this.choixDispo != "n" && this.choixDispo != null && this.choixDispo != []) {
            this.moniteurs.forEach(m => {
              this.choixDispo.choix.forEach(c => {
                if (c.id == m.idMono) m.choixEleve = true;
              });
            });
          }
        })
        .catch((error) => { console.log(error); });
    },

    getFonctionnalite() {
      window.api
        .get("/fonctionnalites/", {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then((response) => {
          this.loadPage++;
          response.data["hydra:member"].forEach(fonc => {
            if (fonc.label === "conduite BM") this.prixBm = fonc.montant;
            else if (fonc.label === "conduite BA") this.prixBa = fonc.montant;
          });
        })
        .catch((error) => { console.log(error); });
    },

    setChoixEleve() {
      this.loadBtn = true;
      if (this.choixDispo == "n") {
        let idBoite = this.boite == "BM" ? 2 : 1;
        window.api
          .patch("/utilisateur/" + this.eleve.id, { boite: idBoite }, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
              "Content-Type": "application/merge-patch+json",
            },
          })
          .then(() => {
            let errorMono = false;
            if (this.choixMono.length != 0) {
              this.choixMono.forEach(e => {
                if (e.lieux == undefined || e.lieux.length == 0) errorMono = true;
              });
            }
            if (!errorMono) {
              window.api
                .post("/choix_dispo_eleves", {
                  eleve: "/api/utilisateurs/" + this.eleve.id,
                  choix: this.choixMono
                }, {
                  headers: { Authorization: "Bearer " + this.$store.state.token },
                })
                .then((response) => {
                  this.loadBtn = false;
                  this.$store.commit("setShowMonoElevePage", false);
                  this.$emit("getEleveInfo");
                  if (this.modalChoixEleve == true) {
                    this.$emit("closeModalChoixEleve");
                    this.$emit("setNewChoixDispo", { id: response.data.id, choix: response.data.choix });
                  }
                  // Réinitialiser le style inline de la nav mobile (display="" laisse le CSS media query décider)
                  const navMobile = document.querySelector("div.nav-mobile");
                  if (navMobile) navMobile.style.display = "";
                  if (this.$store.state.user.role.label !== 'secretaire') {
                    setTimeout(() => window.location.reload(), 0);
                  }
                })
                .catch((error) => { console.log(error); });
            } else {
              alert("Veuillez saisir un lieu pour chaque moniteur sélectionné");
              this.loadBtn = false;
            }
          })
          .catch((error) => { console.log(error); });
      } else {
        let idBoite = this.boite == "BM" ? 2 : 1;
        window.api
          .patch("/utilisateur/" + this.eleve.id, { boite: idBoite }, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
              "Content-Type": "application/merge-patch+json",
            },
          })
          .then(() => {
            let errorMono = false;
            if (this.choixMono.length != 0) {
              this.choixMono.forEach(e => {
                if (e.lieux == undefined || e.lieux.length == 0) errorMono = true;
              });
            }
            if (!errorMono) {
              window.api
                .patch("/choix_dispo_eleves/" + this.choixDispo.id, { choix: this.choixMono }, {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                    "Content-Type": "application/merge-patch+json",
                  },
                })
                .then((response) => {
                  this.loadBtn = false;
                  this.$store.commit("setShowMonoElevePage", false);
                  this.$emit("getEleveInfo");
                  if (this.modalChoixEleve == true) {
                    this.$emit("closeModalChoixEleve");
                    this.$emit("setNewChoixDispo", { id: response.data.id, choix: response.data.choix });
                  }
                  // Réinitialiser le style inline de la nav mobile (display="" laisse le CSS media query décider)
                  const navMobile = document.querySelector("div.nav-mobile");
                  if (navMobile) navMobile.style.display = "";
                  if (this.$store.state.user.role.label !== 'secretaire') {
                    setTimeout(() => window.location.reload(), 0);
                  }
                })
                .catch((error) => { console.log(error); });
            } else {
              alert("Veuillez saisir un lieu pour chaque moniteur sélectionné");
              this.loadBtn = false;
            }
          })
          .catch((error) => { console.log(error); });

      }
    },

  }
};
</script>

<style scoped>

div.choice {
  display: flex;
  justify-content: space-around;
  margin-top: 2em;
}

h4.sstitre {
  text-align: left;
  padding: 12px 16px;
  font-weight: bold;
  border-bottom: 1px solid #e2e8f0;
  margin: 0;
}

/* ===== Colonnes ===== */
.moniteurList {
  border: 1px solid #D2D9E0;
  border-radius: 8px;
  width: 45%;
  height: 500px;
  overflow-y: auto;
  margin: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  background: #fff;
}

.lieuList {
  border: 1px solid #D2D9E0;
  border-radius: 8px;
  width: 45%;
  height: 500px;
  overflow-y: auto;
  margin: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  background: #fff;
}

/* ===== Ligne moniteur ===== */
.mono-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-bottom: 1px solid #e2e8f0;
  transition: background 0.1s;
}
.mono-row:last-child { border-bottom: none; }
.mono-row:hover { background: #f8fafc; }
.mono-row.mono-selected { background: #e8f7f1; }
.mono-row.mono-viewing { background: #eff6ff; }
.mono-row.mono-selected.mono-viewing { background: #d1fae5; }

/* Dot indicateur lieux */
.status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #e2e8f0;
  flex-shrink: 0;
  transition: background 0.2s;
}
.status-dot.dot-on { background: #1a9e6e; }

/* Nom cliquable */
.mono-name {
  flex: 1;
  font-size: 13px;
  font-weight: 500;
  color: #1a1f2e;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 6px;
  border-radius: 6px;
  transition: color 0.12s;
  user-select: none;
}
.mono-name:hover { color: #3b82f6; }
.mono-name.mono-name-viewing { color: #3b82f6; font-weight: 600; }

/* Badge nombre de lieux */
.lieux-count-badge {
  background: #1a9e6e;
  color: #fff;
  border-radius: 10px;
  padding: 1px 7px;
  font-size: 10px;
  font-weight: 700;
}

/* Checkbox moniteur */
.mono-check {
  width: 20px;
  height: 20px;
  border-radius: 6px;
  border: 1.5px solid #e2e8f0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.15s;
}
.mono-check:hover:not(.disabled) { border-color: #1a9e6e; }
.mono-check.checked { background: #1a9e6e; border-color: #1a9e6e; }
.mono-check.disabled { opacity: 0.35; cursor: not-allowed; }

/* ===== Ligne lieu ===== */
.lieu-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding: 10px 14px;
  border-bottom: 1px solid #e2e8f0;
  cursor: pointer;
  transition: background 0.1s;
  text-align: left;
}
.lieu-row:last-child { border-bottom: none; }
.lieu-row:hover:not(.lieu-disabled) { background: #f8fafc; }
.lieu-row.lieu-selected { background: #e8f7f1; }
.lieu-row.lieu-disabled { opacity: 0.5; cursor: not-allowed; }

.lieu-check {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1.5px solid #e2e8f0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  pointer-events: none;
  transition: all 0.12s;
}
.lieu-check.on { background: #1a9e6e; border-color: #1a9e6e; }

.lieu-name {
  flex: 0 0 auto;
  font-size: 13px;
  color: #1a1f2e;
  text-align: left;
}
.lieu-agence-msg {
  flex: 1;
  font-size: 11px;
  color: #b45309;
  font-style: italic;
  text-align: left;
}
.lieu-locked {
  font-size: 11px;
  color: #94a3b8;
  font-style: italic;
}

/* ===== État vide panneau lieux ===== */
.lieux-empty {
  padding: 48px 24px;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
  line-height: 1.7;
}
.lieux-empty-icon {
  font-size: 28px;
  margin-bottom: 10px;
}

/* ===== Header moniteurs avec compteur ===== */
.moniteur-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 0;
}

/* Compteur pill */
.counter-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  box-shadow: 0 1px 3px rgba(0,0,0,.06);
}
.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #e2e8f0;
  transition: background 0.2s;
}
.dot.dot-active { background: #1a9e6e; }
.counter-text { margin-left: 2px; }

/* ===== Footer sélection ===== */
.selection-footer {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px 18px;
  margin-top: 20px;
  box-shadow: 0 1px 3px rgba(0,0,0,.06);
}
.footer-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .07em;
  color: #94a3b8;
  flex-shrink: 0;
}
.footer-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1;
}
.footer-empty {
  font-size: 13px;
  color: #94a3b8;
  font-style: italic;
}
.selection-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: #e8f7f1;
  border: 1px solid #c3ead9;
  border-radius: 20px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  color: #065f46;
}
.chip-lieu-count {
  font-weight: 400;
  color: #1a9e6e;
}
.chip-remove {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #c3ead9;
  color: #065f46;
  border: none;
  cursor: pointer;
  font-size: 13px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all .1s;
  padding: 0;
  font-family: inherit;
}
.chip-remove:hover { background: #1a9e6e; color: #fff; }

/* Bouton valider */
.btn-valider {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 20px;
  border-radius: 10px;
  border: none;
  background: #3b82f6;
  color: #fff;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all .15s;
  flex-shrink: 0;
  margin-left: auto;
}
.btn-valider:hover { background: #2563eb; transform: translateY(-1px); }
.btn-valider-loading { background: #e2e8f0; color: #94a3b8; cursor: not-allowed; transform: none; }
.btn-valider-loading:hover { background: #e2e8f0; transform: none; }



h4.titleMoniteurs {
  text-align: left;
  font-weight: bold;
}

/* Radio boîte */
div.boite { margin-bottom: 1em; }

.container {
  display: block;
  position: relative;
  padding-left: 35px;
  text-align: left;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  user-select: none;
}
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.checkmark {
  position: absolute;
  top: 0; left: 0;
  height: 25px; width: 25px;
  background-color: #eee;
  border-radius: 50%;
}
.container:hover input ~ .checkmark { background-color: #ccc; }
.container input:checked ~ .checkmark { background-color: #2196F3; }
.checkmark:after { content: ""; position: absolute; display: none; }
.container input:checked ~ .checkmark:after { display: block; }
.container .checkmark:after {
  top: 9px; left: 9px;
  width: 8px; height: 8px;
  border-radius: 50%;
  background: white;
}

@media only screen and (min-width: 100px) and (max-width: 1400px) {
  div.choice { display: block; }
  div.choice div.moniteurList { width: 100%; margin-bottom: 20px; }
  div.choice div.lieuList { width: 100%; }
}

</style>